export default {
    setApplicationAccessList(state, data) {
        state.applicationAccessList = data
    },
}
